/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {FlexLayoutModule} from "@angular/flex-layout";
import {FormsModule} from "@angular/forms";

import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatIconModule} from "@angular/material/icon";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatInputModule} from "@angular/material/input";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatGridListModule} from "@angular/material/grid-list";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatDialogModule} from "@angular/material/dialog";
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";

import {BaseModule} from "../../platform/base/base.module";
import {ImageModule} from "../../platform/image/image.module";

import {GuestDialogComponent} from "./guest-dialog/guest-dialog.component";
import {Guests2Component} from "./guests2.component";
import {WelcomeDialogComponent} from "./welcome-dialog/welcome-dialog.component";

import {SessionService} from "../../platform/base/services/session.service";
import {GuestPasswordDialogComponent} from "./guest-password-dialog/guest-password-dialog.component";
import {Guests2Service} from "./guests2.service";
import {BasePipeModule} from "../../platform/base/pipes/base-pipe.module";
import {AigPipeModule} from "../base/pipes/aig-pipe.module";
import {AigiaAuthModule} from "../auth/aigia-auth.module";
import {StuffGuestRegistDialogComponent} from "./guest-regist-dialog/stuff-guest-regist-dialog.component";
import {StuffGuestRegistDialogDirective} from "./guest-regist-dialog/stuff-guest-regist-dialog.directive";
import {YesNoDialogModule} from "../../platform/base/components/yes-no-dialog/yes-no-dialog.module";
import {GuestUserNameDialogComponent} from "./guest-username-dialog/guest-username-dialog.component";
import {MatListModule} from "@angular/material/list";
import {TranslateModule} from "@ngx-translate/core";
import {RouterModule} from "@angular/router";
import {ProfileButtonDirective} from "./profile-button/profile-button.directive";
import {GuestDialogDirective} from "./guest-dialog/guest-dialog.directive";
import {GuestUserNameDialogDirective} from "./guest-username-dialog/guest-username-dialog.directive";
import {GuestPasswordDialogDirective} from "./guest-password-dialog/guest-password-dialog.directive";
import {DeleteDialogDirective} from "./delete-dialog/delete-dialog.directive";
import {UnsubscribeDialogDirective} from "./unsubscribe-dialog/unsubscribe-dialog.directive";
import {WelcomeDialogDirective} from "./welcome-dialog/welcome-dialog.directive";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";

@NgModule({
	declarations: [
		Guests2Component,
		GuestDialogComponent,
		GuestDialogDirective,
		WelcomeDialogComponent,
		WelcomeDialogDirective,
		GuestPasswordDialogComponent,
		GuestPasswordDialogDirective,
		GuestUserNameDialogComponent,
		GuestUserNameDialogDirective,
		StuffGuestRegistDialogDirective,
		StuffGuestRegistDialogComponent,
		DeleteDialogDirective,
		UnsubscribeDialogDirective,

		ProfileButtonDirective
	],
	providers: [
		SessionService,
		Guests2Service,
	],
    imports: [
        CommonModule,
        FormsModule,

        FlexLayoutModule,

        MatDialogModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatInputModule,
        MatGridListModule,
        MatSelectModule,
        MatFormFieldModule,
        MatPaginatorModule,
        MatSlideToggleModule,
        MatCheckboxModule,
        MatDatepickerModule,

        BaseModule,
        ImageModule,
        BasePipeModule,
        AigPipeModule,
        AigiaAuthModule,

        YesNoDialogModule,
        MatListModule,
        TranslateModule,
        RouterModule,
        MatButtonToggleModule,
        MatTooltipModule,
        MatProgressSpinnerModule

    ],
	exports: [
		Guests2Component,
		StuffGuestRegistDialogDirective
	],
	bootstrap: [
		GuestDialogComponent,
		WelcomeDialogComponent,
		GuestPasswordDialogComponent,
		GuestUserNameDialogComponent,
		StuffGuestRegistDialogComponent,
	],
})

export class Guests2Module {
}
